import { Resume } from '@rio/types'
import { SettingsFieldChangeHandler } from 'builder/modules/resumeEditor'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useLayoutBlockCustomisation } from '../../hooks/useLayoutBlockCustomisation'
import {
  SelectGroup,
  SelectControl,
  PlaceholderSpan,
  Label,
  FlexBox,
  ClickableOverlay,
} from './styles'
import { Icons } from './assets'

const STYLES = {
  SelectGroup,
  SelectControl,
  PlaceholderSpan,
  Label,
  FlexBox,
}

type Props = {
  resume: Resume
  onFieldChange?: SettingsFieldChangeHandler
  styles?: typeof STYLES
}

const TRANSLATION = 'builder.resume_editor.document_customization.sidebar.layout_tab'

export const EducationBlockLayoutSelection = (props: Props) => {
  const { i18n } = useI18n()
  const { value, onSelect, isDisabled } = useLayoutBlockCustomisation(
    'educationLayout',
    props.resume,
    props.onFieldChange,
  )
  const Styles = props.styles || STYLES

  return (
    <TooltipV2
      value={i18n.t(`${TRANSLATION}.education_block_layout_warning`)}
      width={250}
      multiline={true}
      position="bottom"
      isActive={isDisabled}
    >
      <Styles.SelectGroup>
        <Styles.SelectControl
          position="left"
          $height={120}
          label={
            <Styles.Label htmlFor="education-block-layout-stacked">
              {i18n.t(`${TRANSLATION}.education_block_layout_label1`)}
            </Styles.Label>
          }
        >
          <input
            type="radio"
            id="education-block-layout-stacked"
            name="educationLayout"
            value="stacked"
            checked={value === 'stacked' && !isDisabled}
            onChange={onSelect}
            disabled={isDisabled}
          />
          <Styles.FlexBox
            as="label"
            gap={8}
            flexDirection="column"
            alignItems="flex-start"
            htmlFor="education-block-layout-stacked"
          >
            <ClickableOverlay />
            <Styles.FlexBox justifyContent="space-between" alignItems="flex-start">
              <Icons.LeftAlignment width={100} />
              <Styles.PlaceholderSpan size="Caption" alignText="right">
                2020
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>
            <Styles.FlexBox justifyContent="space-between" alignItems="flex-start">
              <Icons.LeftAlignment width={100} />
              <Styles.PlaceholderSpan size="Caption" alignText="right">
                2017
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>
          </Styles.FlexBox>
        </Styles.SelectControl>

        <Styles.SelectControl
          position="right"
          $height={120}
          label={
            <Styles.Label htmlFor="education-block-layout-inline">
              {i18n.t(`${TRANSLATION}.education_block_layout_label2`)}
            </Styles.Label>
          }
        >
          <input
            type="radio"
            id="education-block-layout-inline"
            name="educationLayout"
            value="inline"
            checked={value === 'inline' && !isDisabled}
            onChange={onSelect}
            disabled={isDisabled}
          />
          <Styles.FlexBox
            as="label"
            gap={2}
            flexDirection="column"
            alignItems="flex-start"
            htmlFor="education-block-layout-inline"
          >
            <ClickableOverlay />
            <Styles.FlexBox justifyContent="space-between">
              <Icons.InlineBlock width="70%" />
              <Styles.PlaceholderSpan size="Caption" alignText="right">
                2014
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>

            <Styles.FlexBox justifyContent="space-between" alignItems="flex-start">
              <Icons.InlineBlock width="70%" />
              <Styles.PlaceholderSpan size="Caption" alignText="right">
                2017
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>

            <Styles.FlexBox justifyContent="space-between" alignItems="flex-start">
              <Icons.InlineBlock width="70%" />
              <Styles.PlaceholderSpan size="Caption" alignText="right">
                2020
              </Styles.PlaceholderSpan>
            </Styles.FlexBox>
          </Styles.FlexBox>
        </Styles.SelectControl>
      </Styles.SelectGroup>
    </TooltipV2>
  )
}
